/**
 *
 * @module entry
 * @desc {SDK.Services.Internal.Telemetry} entry point.
 *
 */

import TelemetryClientConfiguration from './telemetryClientConfiguration';
import TelemetryClient from './telemetryClient';
import TelemetryClientEndpoint from './telemetryClientEndpoint';
import TelemetryPayload from './telemetryPayload';
import TelemetryResponse from './telemetryResponse';

import StreamSamplePayload from './streamSamplePayload';
import StreamSampleClientPayload from './streamSampleClientPayload';

/**
 *
 * @typedef SDK.Services.Internal.Telemetry
 * @type {Object}
 *
 * @property {TelemetryClientConfiguration} TelemetryClientConfiguration
 * @property {TelemetryClient} TelemetryClient
 * @property {TelemetryClientEndpoint} TelemetryClientEndpoint
 * @property {TelemetryPayload} TelemetryPayload
 * @property {TelemetryResponse} TelemetryResponse
 *
 * @property {StreamSamplePayload} StreamSamplePayload
 * @property {StreamSampleClientPayload} StreamSampleClientPayload
 *
 */

/**
 *
 * @type {SDK.Services.Internal.Telemetry}
 *
 */
export default {

    TelemetryClientConfiguration,
    TelemetryClient,
    TelemetryClientEndpoint,
    TelemetryPayload,
    TelemetryResponse,

    StreamSamplePayload,
    StreamSampleClientPayload

};



// WEBPACK FOOTER //
// ./src/services/internal/telemetry/entry.js